import {
    TOGGLE_ENLARGED_SPECIMEN_MODAL,
} from "./types";

export const toggleEnlargedSpecimenModal = () => async (dispatch) => {
    dispatch({ type: TOGGLE_ENLARGED_SPECIMEN_MODAL });
};